export default function CTASection() {
  return (
    <section className="py-20 px-4 sm:px-6 lg:px-8 bg-gradient-to-br from-cyan-600 to-cyan-700 relative overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-0 left-0 w-64 h-64 bg-white rounded-full -translate-x-1/2 -translate-y-1/2"></div>
        <div className="absolute bottom-0 right-0 w-96 h-96 bg-white rounded-full translate-x-1/2 translate-y-1/2"></div>
      </div>

      <div className="max-w-4xl mx-auto text-center relative z-10">
        {/* Badge */}
        <div className="inline-block mb-6">
          <span className="px-6 py-2 bg-amber-500 text-white font-bold rounded-full text-lg whitespace-nowrap">
            モニター募集中（限定3名様）
          </span>
        </div>

        {/* Heading */}
        <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white mb-6">
          まずはお気軽にご相談ください
        </h2>

        {/* Monitor Price */}
        <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-8 mb-8 border-2 border-white/30">
          <p className="text-xl text-cyan-100 mb-3">モニター特別価格</p>
          <div className="text-6xl font-bold text-amber-400 mb-2">
            ¥3,980
          </div>
          <p className="text-lg text-cyan-100">月額</p>
        </div>

        {/* Contact Info */}
        <div className="mb-8">
          <p className="text-xl text-white mb-2">お問い合わせ</p>
          <a 
            href="mailto:cham.nft@gmail.com"
            className="text-2xl text-amber-400 hover:text-amber-300 underline cursor-pointer"
          >
            cham.nft@gmail.com
          </a>
        </div>

        {/* CTA Button */}
        <a 
          href="https://forms.gle/ztmMFqiChzTiYQCn7"
          target="_blank"
          rel="noopener noreferrer"
          className="inline-block px-12 py-5 bg-amber-500 hover:bg-amber-600 text-white text-xl font-bold rounded-full transition-all duration-300 transform hover:scale-105 shadow-2xl whitespace-nowrap cursor-pointer"
        >
          無料で相談する
        </a>

        {/* Footer Copy */}
        <div className="mt-12 pt-8 border-t border-white/30">
          <p className="text-xl text-white">
            サクッとHP — あなたのお店を、ネットの世界へ。
          </p>
        </div>
      </div>
    </section>
  );
}